module.exports = __webpack_public_path__ + "media/images/dashboards/burden-2832e4ead7b904dcd8b5ed6acacdb93b.png";